<div class="exame-prescricao">
    <div class="item">
        <div class="info">
            <div class="logo logo-primary" *ngIf="isPrescricao">
                <i class="hgi hgi-stroke hgi-prescription"></i>
            </div>

            <div class="logo logo-info" *ngIf="isExame && pedido.urlArquivo">
                <i class="hgi hgi-stroke hgi-google-doc"></i>
            </div>

            <div class="logo logo-danger" *ngIf="isExame &&!pedido.urlArquivo">
                <i class="hgi hgi-stroke hgi-google-doc"></i>
            </div>

            <div class="nome">
                {{ pedido.nome }}
            </div>
        </div>
        <div class="options">
            <button type="button" class="btn btn-outline-secondary" *ngIf="isPrescricao" (click)="download()">
                <i class="hgi hgi-stroke hgi-download-04"></i>
            </button>

            <button type="button" class="btn btn-outline-secondary" *ngIf="isExame && pedido.urlArquivo" (click)="download()">
                <i class="hgi hgi-stroke hgi-download-04"></i>
            </button>
        </div>
    </div>
    <div class="logs">

        <ng-container *ngIf="isPrescricao">
            <p class="log">
                <i class="hgi hgi-stroke hgi-clock-01"></i>
                Prescrição anexada por {{ profissionalNome }} em {{ pedido.dataEnvio | date: 'dd/MM/yyyy HH:mm' }}.
            </p>
        </ng-container>

        <ng-container *ngIf="isExame">
            <p class="log log-danger" *ngIf="!pedido.urlArquivo">
                <i class="hgi hgi-stroke hgi-information-circle"></i>
                O anexo deste exame está pendente.
            </p>

            <p class="log" *ngIf="pedido.urlArquivo">
                <i class="hgi hgi-stroke hgi-clock-01"></i>
                Exame enviado por {{ pacienteNome }} em {{ pedido.dataEnvio | date: 'dd/MM/yyyy HH:mm' }}.
            </p>

            <p class="log">
                <i class="hgi hgi-stroke hgi-clock-01"></i>
                Exame solicitado por {{ profissionalNome }} em {{ pedido.dataSolicitacao | date: 'dd/MM/yyyy HH:mm' }}.
            </p>

        </ng-container>

    </div>

    <div *ngIf="isExame && !pedido.urlArquivo && isPaciente" class="p-2">
        <button type="button" class="btn btn-lg btn-block btn-outline-secondary anexar" (click)="anexarExame()">
            <span>Anexar Exame</span>
            <i class="hgi hgi-stroke hgi-document-attachment"></i>
        </button>
    </div>

</div>
